"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Blockdaemon REST API
 * Blockdaemon REST API provides a RESTful and uniform way to access blockchain resources, with a rich and reusable model across multiple protocols/cryptocurrencies.  [Documentation](https://docs.blockdaemon.com/reference/rest-api-overview)  ### Currently supported protocols:  * algorand   * mainnet * avalanche    * mainnet-c/testnet-c * bitcoin   * mainnet/testnet * bitcoincash   * mainnet/testnet * dogecoin   * mainnet/testnet * ethereum   * mainnet/holesky/sepolia/hoodi * litecoin   * mainnet/testnet * near   * mainnet * optimism   * mainnet * polkadot   * mainnet/westend * polygon   * mainnet/amoy * solana   * mainnet/testnet * stellar   * mainnet/testnet * tezos   * mainnet * tron   * mainnet/nile * xrp   * mainnet  ### Pagination Certain resources contain a lot of data, more than what\'s practical to return for a single request. With the help of pagination, the data is split across multiple responses. Each response returns a subset of the items requested, and a continuation token.  To get the next batch of items, copy the returned continuation token to the continuation query parameter and repeat the request with the new URL. In case no continuation token is returned, there is no more data available.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: support@blockdaemon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionsApi = exports.TransactionsApiFactory = exports.TransactionsApiFp = exports.TransactionsApiAxiosParamCreator = exports.ProtocolAndEndpointSupportApi = exports.ProtocolAndEndpointSupportApiFactory = exports.ProtocolAndEndpointSupportApiFp = exports.ProtocolAndEndpointSupportApiAxiosParamCreator = exports.FeeEstimatorApi = exports.FeeEstimatorApiFactory = exports.FeeEstimatorApiFp = exports.FeeEstimatorApiAxiosParamCreator = exports.BlocksApi = exports.BlocksApiFactory = exports.BlocksApiFp = exports.BlocksApiAxiosParamCreator = exports.BalancesUTXOApi = exports.BalancesUTXOApiFactory = exports.BalancesUTXOApiFp = exports.BalancesUTXOApiAxiosParamCreator = exports.TxOutputStatusEnum = exports.TxStatusEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var TxStatusEnum;
(function (TxStatusEnum) {
    TxStatusEnum["Completed"] = "completed";
    TxStatusEnum["Failed"] = "failed";
})(TxStatusEnum || (exports.TxStatusEnum = TxStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TxOutputStatusEnum;
(function (TxOutputStatusEnum) {
    TxOutputStatusEnum["Mined"] = "mined";
    TxOutputStatusEnum["Unknown"] = "unknown";
})(TxOutputStatusEnum || (exports.TxOutputStatusEnum = TxOutputStatusEnum = {}));
/**
 * BalancesUTXOApi - axios parameter creator
 * @export
 */
const BalancesUTXOApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of account balances by a user-defined account address for the supported currencies.
         * @summary Get a List of Balances for an Address
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddress: (protocol_1, network_1, address_1, assets_1, ...args_1) => __awaiter(this, [protocol_1, network_1, address_1, assets_1, ...args_1], void 0, function* (protocol, network, address, assets, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddress', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddress', 'network', network);
            // verify required parameter 'address' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddress', 'address', address);
            const localVarPath = `/{protocol}/{network}/account/{address}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (assets !== undefined) {
                localVarQueryParameter['assets'] = assets;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of account balances for a user-defined list of account addresses: - The filter allows up to <b>200 addresses</b> for:   - Algorand   - Bitcoin   - Solana   - Stellar   - Ethereum - The filter allows up to <b>10 addresses</b> for other supported protocols.
         * @summary Get a List of Balances for Multiple Addresses
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {AccountsObj} accountsObj
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddresses: (protocol_1, network_1, accountsObj_1, assets_1, ...args_1) => __awaiter(this, [protocol_1, network_1, accountsObj_1, assets_1, ...args_1], void 0, function* (protocol, network, accountsObj, assets, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddresses', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddresses', 'network', network);
            // verify required parameter 'accountsObj' is not null or undefined
            (0, common_1.assertParamExists)('getListOfBalancesByAddresses', 'accountsObj', accountsObj);
            const localVarPath = `/{protocol}/{network}/accounts/`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (assets !== undefined) {
                localVarQueryParameter['assets'] = assets;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountsObj, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a financial report by a user-defined account address between a time period. Default timescale is within the last 30 days.
         * @summary Get a Financial Report for an Address Between a Time Period
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response. Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportByAddress: (protocol_1, network_1, address_1, from_1, to_1, pageToken_1, pageSize_1, ...args_1) => __awaiter(this, [protocol_1, network_1, address_1, from_1, to_1, pageToken_1, pageSize_1, ...args_1], void 0, function* (protocol, network, address, from, to, pageToken, pageSize, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getReportByAddress', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getReportByAddress', 'network', network);
            // verify required parameter 'address' is not null or undefined
            (0, common_1.assertParamExists)('getReportByAddress', 'address', address);
            const localVarPath = `/{protocol}/{network}/account/{address}/report`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BalancesUTXOApiAxiosParamCreator = BalancesUTXOApiAxiosParamCreator;
/**
 * BalancesUTXOApi - functional programming interface
 * @export
 */
const BalancesUTXOApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BalancesUTXOApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a list of account balances by a user-defined account address for the supported currencies.
         * @summary Get a List of Balances for an Address
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddress(protocol, network, address, assets, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListOfBalancesByAddress(protocol, network, address, assets, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of account balances for a user-defined list of account addresses: - The filter allows up to <b>200 addresses</b> for:   - Algorand   - Bitcoin   - Solana   - Stellar   - Ethereum - The filter allows up to <b>10 addresses</b> for other supported protocols.
         * @summary Get a List of Balances for Multiple Addresses
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {AccountsObj} accountsObj
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a financial report by a user-defined account address between a time period. Default timescale is within the last 30 days.
         * @summary Get a Financial Report for an Address Between a Time Period
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response. Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.BalancesUTXOApiFp = BalancesUTXOApiFp;
/**
 * BalancesUTXOApi - factory interface
 * @export
 */
const BalancesUTXOApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BalancesUTXOApiFp)(configuration);
    return {
        /**
         * Returns a list of account balances by a user-defined account address for the supported currencies.
         * @summary Get a List of Balances for an Address
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddress(protocol, network, address, assets, options) {
            return localVarFp.getListOfBalancesByAddress(protocol, network, address, assets, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of account balances for a user-defined list of account addresses: - The filter allows up to <b>200 addresses</b> for:   - Algorand   - Bitcoin   - Solana   - Stellar   - Ethereum - The filter allows up to <b>10 addresses</b> for other supported protocols.
         * @summary Get a List of Balances for Multiple Addresses
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {AccountsObj} accountsObj
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options) {
            return localVarFp.getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a financial report by a user-defined account address between a time period. Default timescale is within the last 30 days.
         * @summary Get a Financial Report for an Address Between a Time Period
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response. Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options) {
            return localVarFp.getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BalancesUTXOApiFactory = BalancesUTXOApiFactory;
/**
 * BalancesUTXOApi - object-oriented interface
 * @export
 * @class BalancesUTXOApi
 * @extends {BaseAPI}
 */
class BalancesUTXOApi extends base_1.BaseAPI {
    /**
     * Returns a list of account balances by a user-defined account address for the supported currencies.
     * @summary Get a List of Balances for an Address
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} address The account address of the protocol.
     * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalancesUTXOApi
     */
    getListOfBalancesByAddress(protocol, network, address, assets, options) {
        return (0, exports.BalancesUTXOApiFp)(this.configuration).getListOfBalancesByAddress(protocol, network, address, assets, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of account balances for a user-defined list of account addresses: - The filter allows up to <b>200 addresses</b> for:   - Algorand   - Bitcoin   - Solana   - Stellar   - Ethereum - The filter allows up to <b>10 addresses</b> for other supported protocols.
     * @summary Get a List of Balances for Multiple Addresses
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {AccountsObj} accountsObj
     * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalancesUTXOApi
     */
    getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options) {
        return (0, exports.BalancesUTXOApiFp)(this.configuration).getListOfBalancesByAddresses(protocol, network, accountsObj, assets, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a financial report by a user-defined account address between a time period. Default timescale is within the last 30 days.
     * @summary Get a Financial Report for an Address Between a Time Period
     * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} address The account address of the protocol.
     * @param {number} [from] The Unix Timestamp from where to start.
     * @param {number} [to] The Unix Timestamp from where to end.
     * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
     * @param {number} [pageSize] The max number of items to return in a response. Defaults to 50k and is capped at 100k.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalancesUTXOApi
     */
    getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options) {
        return (0, exports.BalancesUTXOApiFp)(this.configuration).getReportByAddress(protocol, network, address, from, to, pageToken, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BalancesUTXOApi = BalancesUTXOApi;
/**
 * BlocksApi - axios parameter creator
 * @export
 */
const BlocksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a block and all its transactions by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block by Number or Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockByNumber: (protocol_1, network_1, blockIdentifier_1, ...args_1) => __awaiter(this, [protocol_1, network_1, blockIdentifier_1, ...args_1], void 0, function* (protocol, network, blockIdentifier, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getBlockByNumber', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getBlockByNumber', 'network', network);
            // verify required parameter 'blockIdentifier' is not null or undefined
            (0, common_1.assertParamExists)('getBlockByNumber', 'blockIdentifier', blockIdentifier);
            const localVarPath = `/{protocol}/{network}/block/{block_identifier}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"block_identifier"}}`, encodeURIComponent(String(blockIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the minimal block data, block header, by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block Identifier by Number of Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifierByNumber: (protocol_1, network_1, blockIdentifier_1, ...args_1) => __awaiter(this, [protocol_1, network_1, blockIdentifier_1, ...args_1], void 0, function* (protocol, network, blockIdentifier, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getBlockIdentifierByNumber', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getBlockIdentifierByNumber', 'network', network);
            // verify required parameter 'blockIdentifier' is not null or undefined
            (0, common_1.assertParamExists)('getBlockIdentifierByNumber', 'blockIdentifier', blockIdentifier);
            const localVarPath = `/{protocol}/{network}/block_identifier/{block_identifier}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"block_identifier"}}`, encodeURIComponent(String(blockIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of minimal block data, block headers such as block hash and block number.
         * @summary Get a List of Block Identifiers
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;,&#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifiers: (protocol_1, network_1, order_1, pageToken_1, pageSize_1, ...args_1) => __awaiter(this, [protocol_1, network_1, order_1, pageToken_1, pageSize_1, ...args_1], void 0, function* (protocol, network, order, pageToken, pageSize, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getBlockIdentifiers', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getBlockIdentifiers', 'network', network);
            const localVarPath = `/{protocol}/{network}/block_identifiers`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the current block id (hash) of the protocol.
         * @summary Get the Current Block Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockHash: (protocol_1, network_1, ...args_1) => __awaiter(this, [protocol_1, network_1, ...args_1], void 0, function* (protocol, network, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getCurrentBlockHash', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getCurrentBlockHash', 'network', network);
            const localVarPath = `/{protocol}/{network}/sync/block_id`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the current block number/height of the protocol.
         * @summary Get the Current Block Number
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockNumber: (protocol_1, network_1, ...args_1) => __awaiter(this, [protocol_1, network_1, ...args_1], void 0, function* (protocol, network, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getCurrentBlockNumber', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getCurrentBlockNumber', 'network', network);
            const localVarPath = `/{protocol}/{network}/sync/block_number`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BlocksApiAxiosParamCreator = BlocksApiAxiosParamCreator;
/**
 * BlocksApi - functional programming interface
 * @export
 */
const BlocksApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BlocksApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get a block and all its transactions by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block by Number or Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockByNumber(protocol, network, blockIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBlockByNumber(protocol, network, blockIdentifier, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the minimal block data, block header, by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block Identifier by Number of Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifierByNumber(protocol, network, blockIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBlockIdentifierByNumber(protocol, network, blockIdentifier, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of minimal block data, block headers such as block hash and block number.
         * @summary Get a List of Block Identifiers
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;,&#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the current block id (hash) of the protocol.
         * @summary Get the Current Block Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockHash(protocol, network, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentBlockHash(protocol, network, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns the current block number/height of the protocol.
         * @summary Get the Current Block Number
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockNumber(protocol, network, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentBlockNumber(protocol, network, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.BlocksApiFp = BlocksApiFp;
/**
 * BlocksApi - factory interface
 * @export
 */
const BlocksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BlocksApiFp)(configuration);
    return {
        /**
         * Get a block and all its transactions by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block by Number or Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockByNumber(protocol, network, blockIdentifier, options) {
            return localVarFp.getBlockByNumber(protocol, network, blockIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the minimal block data, block header, by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
         * @summary Get a Block Identifier by Number of Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} blockIdentifier The block identifier, hash or number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifierByNumber(protocol, network, blockIdentifier, options) {
            return localVarFp.getBlockIdentifierByNumber(protocol, network, blockIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of minimal block data, block headers such as block hash and block number.
         * @summary Get a List of Block Identifiers
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;,&#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options) {
            return localVarFp.getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current block id (hash) of the protocol.
         * @summary Get the Current Block Hash
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockHash(protocol, network, options) {
            return localVarFp.getCurrentBlockHash(protocol, network, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current block number/height of the protocol.
         * @summary Get the Current Block Number
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentBlockNumber(protocol, network, options) {
            return localVarFp.getCurrentBlockNumber(protocol, network, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BlocksApiFactory = BlocksApiFactory;
/**
 * BlocksApi - object-oriented interface
 * @export
 * @class BlocksApi
 * @extends {BaseAPI}
 */
class BlocksApi extends base_1.BaseAPI {
    /**
     * Get a block and all its transactions by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
     * @summary Get a Block by Number or Hash
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} blockIdentifier The block identifier, hash or number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    getBlockByNumber(protocol, network, blockIdentifier, options) {
        return (0, exports.BlocksApiFp)(this.configuration).getBlockByNumber(protocol, network, blockIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the minimal block data, block header, by a user-defined block number or block hash.   Use `-1` or `current` parameter to return the current block.
     * @summary Get a Block Identifier by Number of Hash
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} blockIdentifier The block identifier, hash or number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    getBlockIdentifierByNumber(protocol, network, blockIdentifier, options) {
        return (0, exports.BlocksApiFp)(this.configuration).getBlockIdentifierByNumber(protocol, network, blockIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of minimal block data, block headers such as block hash and block number.
     * @summary Get a List of Block Identifiers
     * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;,&#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;tezos&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {'desc' | 'asc'} [order] The pagination order.
     * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
     * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options) {
        return (0, exports.BlocksApiFp)(this.configuration).getBlockIdentifiers(protocol, network, order, pageToken, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the current block id (hash) of the protocol.
     * @summary Get the Current Block Hash
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    getCurrentBlockHash(protocol, network, options) {
        return (0, exports.BlocksApiFp)(this.configuration).getCurrentBlockHash(protocol, network, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the current block number/height of the protocol.
     * @summary Get the Current Block Number
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlocksApi
     */
    getCurrentBlockNumber(protocol, network, options) {
        return (0, exports.BlocksApiFp)(this.configuration).getCurrentBlockNumber(protocol, network, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BlocksApi = BlocksApi;
/**
 * FeeEstimatorApi - axios parameter creator
 * @export
 */
const FeeEstimatorApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns fee estimation in decimals.This endpoint will return 3 fee estimations: fast, medium and slow.
         * @summary Get the Fee Estimation
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60; and &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimate: (protocol_1, network_1, ...args_1) => __awaiter(this, [protocol_1, network_1, ...args_1], void 0, function* (protocol, network, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getFeeEstimate', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getFeeEstimate', 'network', network);
            const localVarPath = `/{protocol}/{network}/tx/estimate_fee`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FeeEstimatorApiAxiosParamCreator = FeeEstimatorApiAxiosParamCreator;
/**
 * FeeEstimatorApi - functional programming interface
 * @export
 */
const FeeEstimatorApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FeeEstimatorApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns fee estimation in decimals.This endpoint will return 3 fee estimations: fast, medium and slow.
         * @summary Get the Fee Estimation
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60; and &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimate(protocol, network, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeeEstimate(protocol, network, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FeeEstimatorApiFp = FeeEstimatorApiFp;
/**
 * FeeEstimatorApi - factory interface
 * @export
 */
const FeeEstimatorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FeeEstimatorApiFp)(configuration);
    return {
        /**
         * Returns fee estimation in decimals.This endpoint will return 3 fee estimations: fast, medium and slow.
         * @summary Get the Fee Estimation
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60; and &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimate(protocol, network, options) {
            return localVarFp.getFeeEstimate(protocol, network, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FeeEstimatorApiFactory = FeeEstimatorApiFactory;
/**
 * FeeEstimatorApi - object-oriented interface
 * @export
 * @class FeeEstimatorApi
 * @extends {BaseAPI}
 */
class FeeEstimatorApi extends base_1.BaseAPI {
    /**
     * Returns fee estimation in decimals.This endpoint will return 3 fee estimations: fast, medium and slow.
     * @summary Get the Fee Estimation
     * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60; and &#x60;solana&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeEstimatorApi
     */
    getFeeEstimate(protocol, network, options) {
        return (0, exports.FeeEstimatorApiFp)(this.configuration).getFeeEstimate(protocol, network, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FeeEstimatorApi = FeeEstimatorApi;
/**
 * ProtocolAndEndpointSupportApi - axios parameter creator
 * @export
 */
const ProtocolAndEndpointSupportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Provides information about supported endpoints and generic protocol information.
         * @summary Get the Protocol Info
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolEndpoints: (protocol_1, network_1, ...args_1) => __awaiter(this, [protocol_1, network_1, ...args_1], void 0, function* (protocol, network, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getProtocolEndpoints', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getProtocolEndpoints', 'network', network);
            const localVarPath = `/{protocol}/{network}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides a list of supported protocols and networks.
         * @summary Get the Protocols Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolsList: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ProtocolAndEndpointSupportApiAxiosParamCreator = ProtocolAndEndpointSupportApiAxiosParamCreator;
/**
 * ProtocolAndEndpointSupportApi - functional programming interface
 * @export
 */
const ProtocolAndEndpointSupportApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ProtocolAndEndpointSupportApiAxiosParamCreator)(configuration);
    return {
        /**
         * Provides information about supported endpoints and generic protocol information.
         * @summary Get the Protocol Info
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolEndpoints(protocol, network, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProtocolEndpoints(protocol, network, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Provides a list of supported protocols and networks.
         * @summary Get the Protocols Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolsList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProtocolsList(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ProtocolAndEndpointSupportApiFp = ProtocolAndEndpointSupportApiFp;
/**
 * ProtocolAndEndpointSupportApi - factory interface
 * @export
 */
const ProtocolAndEndpointSupportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ProtocolAndEndpointSupportApiFp)(configuration);
    return {
        /**
         * Provides information about supported endpoints and generic protocol information.
         * @summary Get the Protocol Info
         * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolEndpoints(protocol, network, options) {
            return localVarFp.getProtocolEndpoints(protocol, network, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides a list of supported protocols and networks.
         * @summary Get the Protocols Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProtocolsList(options) {
            return localVarFp.getProtocolsList(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ProtocolAndEndpointSupportApiFactory = ProtocolAndEndpointSupportApiFactory;
/**
 * ProtocolAndEndpointSupportApi - object-oriented interface
 * @export
 * @class ProtocolAndEndpointSupportApi
 * @extends {BaseAPI}
 */
class ProtocolAndEndpointSupportApi extends base_1.BaseAPI {
    /**
     * Provides information about supported endpoints and generic protocol information.
     * @summary Get the Protocol Info
     * @param {string} protocol Protocol handle, one of:  &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;near&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtocolAndEndpointSupportApi
     */
    getProtocolEndpoints(protocol, network, options) {
        return (0, exports.ProtocolAndEndpointSupportApiFp)(this.configuration).getProtocolEndpoints(protocol, network, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides a list of supported protocols and networks.
     * @summary Get the Protocols Overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtocolAndEndpointSupportApi
     */
    getProtocolsList(options) {
        return (0, exports.ProtocolAndEndpointSupportApiFp)(this.configuration).getProtocolsList(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProtocolAndEndpointSupportApi = ProtocolAndEndpointSupportApi;
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
const TransactionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a transaction by a user-defined transaction hash.
         * @summary Get a Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxByHash: (protocol_1, network_1, hash_1, ...args_1) => __awaiter(this, [protocol_1, network_1, hash_1, ...args_1], void 0, function* (protocol, network, hash, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getTxByHash', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getTxByHash', 'network', network);
            // verify required parameter 'hash' is not null or undefined
            (0, common_1.assertParamExists)('getTxByHash', 'hash', hash);
            const localVarPath = `/{protocol}/{network}/tx/{hash}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the number of transaction confirmations by a user-defined transaction hash.
         * @summary Get the Transaction Confirmations
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxConfirmations: (protocol_1, network_1, hash_1, ...args_1) => __awaiter(this, [protocol_1, network_1, hash_1, ...args_1], void 0, function* (protocol, network, hash, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getTxConfirmations', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getTxConfirmations', 'network', network);
            // verify required parameter 'hash' is not null or undefined
            (0, common_1.assertParamExists)('getTxConfirmations', 'hash', hash);
            const localVarPath = `/{protocol}/{network}/tx/{hash}/confirmations`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a transaction output by a user-defined transaction hash and the transaction output index.
         * @summary Get a Transaction Output by Hash and Index
         * @param {string} protocol Protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {number} index The transaction output index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutputByHashAndIndex: (protocol_1, network_1, hash_1, index_1, ...args_1) => __awaiter(this, [protocol_1, network_1, hash_1, index_1, ...args_1], void 0, function* (protocol, network, hash, index, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getTxOutputByHashAndIndex', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getTxOutputByHashAndIndex', 'network', network);
            // verify required parameter 'hash' is not null or undefined
            (0, common_1.assertParamExists)('getTxOutputByHashAndIndex', 'hash', hash);
            // verify required parameter 'index' is not null or undefined
            (0, common_1.assertParamExists)('getTxOutputByHashAndIndex', 'index', index);
            const localVarPath = `/{protocol}/{network}/tx/{hash}/{index}`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a List of transactions, starting with the lastest one. Each call returns an array of the entire list.
         * @summary Get a List of Transactions
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} [blockHash] Filter by block hash. You can specify only one block hash at a time.
         * @param {number} [blockNumber] Filter by block number.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxs: (protocol_1, network_1, blockHash_1, blockNumber_1, assets_1, order_1, pageToken_1, pageSize_1, ...args_1) => __awaiter(this, [protocol_1, network_1, blockHash_1, blockNumber_1, assets_1, order_1, pageToken_1, pageSize_1, ...args_1], void 0, function* (protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getTxs', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getTxs', 'network', network);
            const localVarPath = `/{protocol}/{network}/txs`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (blockHash !== undefined) {
                localVarQueryParameter['block_hash'] = blockHash;
            }
            if (blockNumber !== undefined) {
                localVarQueryParameter['block_number'] = blockNumber;
            }
            if (assets !== undefined) {
                localVarQueryParameter['assets'] = assets;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the transactions that an address was involved with, from newest to oldest.
         * @summary Get a List of Transactions for a Given Address
         * @param {string} protocol The protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;tezos&#x60;, &#x60;stellar&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {number} [from] Unix Timestamp from where to start. The date range is exclusive (results include transactions starting 1 second after this timestamp).
         * @param {number} [to] Unix Timestamp from where to end. The date range is exclusive (results include transactions up to 1 second before this timestamp).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxsByAddress: (protocol_1, network_1, address_1, assets_1, from_1, to_1, order_1, pageToken_1, pageSize_1, ...args_1) => __awaiter(this, [protocol_1, network_1, address_1, assets_1, from_1, to_1, order_1, pageToken_1, pageSize_1, ...args_1], void 0, function* (protocol, network, address, assets, from, to, order, pageToken, pageSize, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getTxsByAddress', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getTxsByAddress', 'network', network);
            // verify required parameter 'address' is not null or undefined
            (0, common_1.assertParamExists)('getTxsByAddress', 'address', address);
            const localVarPath = `/{protocol}/{network}/account/{address}/txs`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (assets !== undefined) {
                localVarQueryParameter['assets'] = assets;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the transaction inputs and outputs following the BTC\'s UTXO model definition by a user-definied account address.
         * @summary Get a List of Transaction Inputs and Outputs
         * @param {string} protocol The protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {boolean} [spent] Whether the transaction output was spent or not.
         * @param {boolean} [checkMempool] Whether to check for UTXOs spent in the mempool as well as UTXOs pending in the mempool.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUTXOByAccount: (protocol_1, network_1, address_1, spent_1, checkMempool_1, from_1, to_1, order_1, pageToken_1, pageSize_1, ...args_1) => __awaiter(this, [protocol_1, network_1, address_1, spent_1, checkMempool_1, from_1, to_1, order_1, pageToken_1, pageSize_1, ...args_1], void 0, function* (protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('getUTXOByAccount', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('getUTXOByAccount', 'network', network);
            // verify required parameter 'address' is not null or undefined
            (0, common_1.assertParamExists)('getUTXOByAccount', 'address', address);
            const localVarPath = `/{protocol}/{network}/account/{address}/utxo`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (spent !== undefined) {
                localVarQueryParameter['spent'] = spent;
            }
            if (checkMempool !== undefined) {
                localVarQueryParameter['check_mempool'] = checkMempool;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates an unsigned transaction.  **Note** that Ethereum currently only supports singular transaction destinations.
         * @summary Create an Unsigned Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;ethereum&#x60;, &#x60;dogecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {TxCreate} txCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txCreate: (protocol_1, network_1, txCreate_1, ...args_1) => __awaiter(this, [protocol_1, network_1, txCreate_1, ...args_1], void 0, function* (protocol, network, txCreate, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('txCreate', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('txCreate', 'network', network);
            // verify required parameter 'txCreate' is not null or undefined
            (0, common_1.assertParamExists)('txCreate', 'txCreate', txCreate);
            const localVarPath = `/{protocol}/{network}/tx/create`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(txCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit a signed transaction to the network.  **Note**: A successful transaction may still be rejected on chain or not processed due to a too low fee. You can monitor successful transactions through Universal websockets.
         * @summary Submit a Signed Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {SignedTx} signedTx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txSend: (protocol_1, network_1, signedTx_1, ...args_1) => __awaiter(this, [protocol_1, network_1, signedTx_1, ...args_1], void 0, function* (protocol, network, signedTx, options = {}) {
            // verify required parameter 'protocol' is not null or undefined
            (0, common_1.assertParamExists)('txSend', 'protocol', protocol);
            // verify required parameter 'network' is not null or undefined
            (0, common_1.assertParamExists)('txSend', 'network', network);
            // verify required parameter 'signedTx' is not null or undefined
            (0, common_1.assertParamExists)('txSend', 'signedTx', signedTx);
            const localVarPath = `/{protocol}/{network}/tx/send`
                .replace(`{${"protocol"}}`, encodeURIComponent(String(protocol)))
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signedTx, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TransactionsApiAxiosParamCreator = TransactionsApiAxiosParamCreator;
/**
 * TransactionsApi - functional programming interface
 * @export
 */
const TransactionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TransactionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a transaction by a user-defined transaction hash.
         * @summary Get a Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxByHash(protocol, network, hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxByHash(protocol, network, hash, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns the number of transaction confirmations by a user-defined transaction hash.
         * @summary Get the Transaction Confirmations
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxConfirmations(protocol, network, hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxConfirmations(protocol, network, hash, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a transaction output by a user-defined transaction hash and the transaction output index.
         * @summary Get a Transaction Output by Hash and Index
         * @param {string} protocol Protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {number} index The transaction output index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutputByHashAndIndex(protocol, network, hash, index, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxOutputByHashAndIndex(protocol, network, hash, index, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a List of transactions, starting with the lastest one. Each call returns an array of the entire list.
         * @summary Get a List of Transactions
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} [blockHash] Filter by block hash. You can specify only one block hash at a time.
         * @param {number} [blockNumber] Filter by block number.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns the transactions that an address was involved with, from newest to oldest.
         * @summary Get a List of Transactions for a Given Address
         * @param {string} protocol The protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;tezos&#x60;, &#x60;stellar&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {number} [from] Unix Timestamp from where to start. The date range is exclusive (results include transactions starting 1 second after this timestamp).
         * @param {number} [to] Unix Timestamp from where to end. The date range is exclusive (results include transactions up to 1 second before this timestamp).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns the transaction inputs and outputs following the BTC\'s UTXO model definition by a user-definied account address.
         * @summary Get a List of Transaction Inputs and Outputs
         * @param {string} protocol The protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {boolean} [spent] Whether the transaction output was spent or not.
         * @param {boolean} [checkMempool] Whether to check for UTXOs spent in the mempool as well as UTXOs pending in the mempool.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates an unsigned transaction.  **Note** that Ethereum currently only supports singular transaction destinations.
         * @summary Create an Unsigned Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;ethereum&#x60;, &#x60;dogecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {TxCreate} txCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txCreate(protocol, network, txCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.txCreate(protocol, network, txCreate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Submit a signed transaction to the network.  **Note**: A successful transaction may still be rejected on chain or not processed due to a too low fee. You can monitor successful transactions through Universal websockets.
         * @summary Submit a Signed Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {SignedTx} signedTx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txSend(protocol, network, signedTx, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.txSend(protocol, network, signedTx, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TransactionsApiFp = TransactionsApiFp;
/**
 * TransactionsApi - factory interface
 * @export
 */
const TransactionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TransactionsApiFp)(configuration);
    return {
        /**
         * Returns a transaction by a user-defined transaction hash.
         * @summary Get a Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxByHash(protocol, network, hash, options) {
            return localVarFp.getTxByHash(protocol, network, hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the number of transaction confirmations by a user-defined transaction hash.
         * @summary Get the Transaction Confirmations
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxConfirmations(protocol, network, hash, options) {
            return localVarFp.getTxConfirmations(protocol, network, hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a transaction output by a user-defined transaction hash and the transaction output index.
         * @summary Get a Transaction Output by Hash and Index
         * @param {string} protocol Protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} hash The transaction hash.
         * @param {number} index The transaction output index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutputByHashAndIndex(protocol, network, hash, index, options) {
            return localVarFp.getTxOutputByHashAndIndex(protocol, network, hash, index, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a List of transactions, starting with the lastest one. Each call returns an array of the entire list.
         * @summary Get a List of Transactions
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} [blockHash] Filter by block hash. You can specify only one block hash at a time.
         * @param {number} [blockNumber] Filter by block number.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options) {
            return localVarFp.getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the transactions that an address was involved with, from newest to oldest.
         * @summary Get a List of Transactions for a Given Address
         * @param {string} protocol The protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;tezos&#x60;, &#x60;stellar&#x60;, &#x60;xrp&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
         * @param {number} [from] Unix Timestamp from where to start. The date range is exclusive (results include transactions starting 1 second after this timestamp).
         * @param {number} [to] Unix Timestamp from where to end. The date range is exclusive (results include transactions up to 1 second before this timestamp).
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options) {
            return localVarFp.getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the transaction inputs and outputs following the BTC\'s UTXO model definition by a user-definied account address.
         * @summary Get a List of Transaction Inputs and Outputs
         * @param {string} protocol The protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {string} address The account address of the protocol.
         * @param {boolean} [spent] Whether the transaction output was spent or not.
         * @param {boolean} [checkMempool] Whether to check for UTXOs spent in the mempool as well as UTXOs pending in the mempool.
         * @param {number} [from] The Unix Timestamp from where to start.
         * @param {number} [to] The Unix Timestamp from where to end.
         * @param {'desc' | 'asc'} [order] The pagination order.
         * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
         * @param {number} [pageSize] The max number of items to return in a response Defaults to 50k and is capped at 100k.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options) {
            return localVarFp.getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an unsigned transaction.  **Note** that Ethereum currently only supports singular transaction destinations.
         * @summary Create an Unsigned Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;ethereum&#x60;, &#x60;dogecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {TxCreate} txCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txCreate(protocol, network, txCreate, options) {
            return localVarFp.txCreate(protocol, network, txCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a signed transaction to the network.  **Note**: A successful transaction may still be rejected on chain or not processed due to a too low fee. You can monitor successful transactions through Universal websockets.
         * @summary Submit a Signed Transaction
         * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
         * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
         * @param {SignedTx} signedTx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        txSend(protocol, network, signedTx, options) {
            return localVarFp.txSend(protocol, network, signedTx, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TransactionsApiFactory = TransactionsApiFactory;
/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
class TransactionsApi extends base_1.BaseAPI {
    /**
     * Returns a transaction by a user-defined transaction hash.
     * @summary Get a Transaction
     * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} hash The transaction hash.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getTxByHash(protocol, network, hash, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getTxByHash(protocol, network, hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the number of transaction confirmations by a user-defined transaction hash.
     * @summary Get the Transaction Confirmations
     * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;stellar&#x60;, &#x60;tezos&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} hash The transaction hash.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getTxConfirmations(protocol, network, hash, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getTxConfirmations(protocol, network, hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a transaction output by a user-defined transaction hash and the transaction output index.
     * @summary Get a Transaction Output by Hash and Index
     * @param {string} protocol Protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} hash The transaction hash.
     * @param {number} index The transaction output index.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getTxOutputByHashAndIndex(protocol, network, hash, index, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getTxOutputByHashAndIndex(protocol, network, hash, index, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a List of transactions, starting with the lastest one. Each call returns an array of the entire list.
     * @summary Get a List of Transactions
     * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;stellar&#x60; &#x60;tezos&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} [blockHash] Filter by block hash. You can specify only one block hash at a time.
     * @param {number} [blockNumber] Filter by block number.
     * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
     * @param {'desc' | 'asc'} [order] The pagination order.
     * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
     * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getTxs(protocol, network, blockHash, blockNumber, assets, order, pageToken, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the transactions that an address was involved with, from newest to oldest.
     * @summary Get a List of Transactions for a Given Address
     * @param {string} protocol The protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;, &#x60;tezos&#x60;, &#x60;stellar&#x60;, &#x60;xrp&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} address The account address of the protocol.
     * @param {string} [assets] Comma-separated list of asset paths to filter. If the list is empty or all elements are empty, this filter has no effect. Filtering by asset is applicable only for:   - **Balances endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoincash&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polygon&#x60;, &#x60;polkadot&#x60;, &#x60;solana&#x60;   - **Transactions endpoints:** &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;ethereum&#x60;  Find all the asset paths on this [page](https://docs.blockdaemon.com/reference/available-currencies-and-tokens).
     * @param {number} [from] Unix Timestamp from where to start. The date range is exclusive (results include transactions starting 1 second after this timestamp).
     * @param {number} [to] Unix Timestamp from where to end. The date range is exclusive (results include transactions up to 1 second before this timestamp).
     * @param {'desc' | 'asc'} [order] The pagination order.
     * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
     * @param {number} [pageSize] Max number of items to return in a response. Defaults to 25 and is capped at 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getTxsByAddress(protocol, network, address, assets, from, to, order, pageToken, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the transaction inputs and outputs following the BTC\'s UTXO model definition by a user-definied account address.
     * @summary Get a List of Transaction Inputs and Outputs
     * @param {string} protocol The protocol handle, one of: &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;litecoin&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {string} address The account address of the protocol.
     * @param {boolean} [spent] Whether the transaction output was spent or not.
     * @param {boolean} [checkMempool] Whether to check for UTXOs spent in the mempool as well as UTXOs pending in the mempool.
     * @param {number} [from] The Unix Timestamp from where to start.
     * @param {number} [to] The Unix Timestamp from where to end.
     * @param {'desc' | 'asc'} [order] The pagination order.
     * @param {string} [pageToken] The token to retrieve more items in the next request. Use the &#x60;next_page_token&#x60; returned from the previous response for this parameter.
     * @param {number} [pageSize] The max number of items to return in a response Defaults to 50k and is capped at 100k.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).getUTXOByAccount(protocol, network, address, spent, checkMempool, from, to, order, pageToken, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates an unsigned transaction.  **Note** that Ethereum currently only supports singular transaction destinations.
     * @summary Create an Unsigned Transaction
     * @param {string} protocol Protocol handle, one of: &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;ethereum&#x60;, &#x60;dogecoin&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {TxCreate} txCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    txCreate(protocol, network, txCreate, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).txCreate(protocol, network, txCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit a signed transaction to the network.  **Note**: A successful transaction may still be rejected on chain or not processed due to a too low fee. You can monitor successful transactions through Universal websockets.
     * @summary Submit a Signed Transaction
     * @param {string} protocol Protocol handle, one of: &#x60;algorand&#x60;, &#x60;avalanche&#x60;, &#x60;bitcoin&#x60;, &#x60;bitcoincash&#x60;, &#x60;dogecoin&#x60;, &#x60;ethereum&#x60;, &#x60;litecoin&#x60;, &#x60;optimism&#x60;, &#x60;polkadot&#x60;, &#x60;polygon&#x60;, &#x60;solana&#x60;.
     * @param {string} network Which network to target. Available networks can be found in the list of supported protocols or with /{protocol}.
     * @param {SignedTx} signedTx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    txSend(protocol, network, signedTx, options) {
        return (0, exports.TransactionsApiFp)(this.configuration).txSend(protocol, network, signedTx, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TransactionsApi = TransactionsApi;
